import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import Bottom from './Bottom';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentNice extends Component {
  componentDidMount() {
    this.props.orderStore.setPaymentMethod('1');

    const script = document.createElement('script');
    script.src = 'https://paypro.inicis.com/std/payment/js/INIPayPro_v2.js';
    script.async = true;
    document.body.appendChild(script);
  }

  // 결제방법 변경
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  pay = async () => {
    const { commonStore, menuStore, orderStore } = this.props;

    var requestData = {
      // 필수
      P_MID: this.props.menuStore.storeData.merchantID,
      P_OID: orderStore.orderAuthData.orderId,
      P_PAY_TYPE: 'CARD',
      P_DEVICE_TYPE: isMobile ? 'MOBILE' : 'WEB',
      P_IDCCODE: 'Y',
      P_AMT: orderStore.paymentAmount.toString(),
      P_GOODS: orderStore.paymentMenuName,
      P_UNAME: orderStore.orderData.userId,
      P_NEXT_URL: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/inicis?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`,
      P_TIMESTAMP: orderStore.orderAuthData.timestamp,
      P_CHKFAKE: orderStore.orderAuthData.signData,
      P_RESERVED: '',

      // 선택
      P_CLOSE_URL: window.location.href,
      P_CHARSET: 'UTF-8',
      P_TAX: orderStore.orderData.paymentTax.toString(),
      P_TAXFREE: orderStore.orderData.paymentTaxFree.toString(),
      P_NOTI: `${menuStore.storeData.companyId}|${menuStore.storeData.storeCode}|${orderStore.isLiteOrder}`,
    };

    /*global INIPayPro*/
    INIPayPro.requestPayment(requestData);
  };

  render() {
    const { t, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        {menuStore.storeData.isEzwelPayUsed && (
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'일반결제'} />
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              </RadioGroup>
            </Grid>
          </Grid>
        )}

        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentNice);
